/* Alpha Biologix — theme interactions */
(function () {
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  ready(function () {
    // scroll reveal
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: .12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

    // count-up
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, target = parseFloat(el.dataset.count), suf = el.dataset.suffix || '';
        var dec = (target % 1 !== 0) ? 1 : 0, steps = 45, inc = target / steps, i = 0, cur = 0;
        var t = setInterval(function () {
          i++; cur += inc;
          if (i >= steps) { cur = target; clearInterval(t); }
          el.textContent = cur.toFixed(dec) + suf;
        }, 18);
        cio.unobserve(el);
      });
    }, { threshold: .5 });
    document.querySelectorAll('[data-count]').forEach(function (c) { cio.observe(c); });

    // reconstitution calculator
    var mg = document.getElementById('calc-mg'), ml = document.getElementById('calc-ml'), out = document.getElementById('calc-conc');
    function calc(){ if(!mg||!ml||!out) return; var m=parseFloat(mg.value)||0, l=parseFloat(ml.value)||1; out.textContent=(m/l).toFixed(2); }
    if (mg && ml) { mg.addEventListener('input', calc); ml.addEventListener('input', calc); }

    // lot verify (demo reveal)
    document.querySelectorAll('[data-lot-verify]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = document.getElementById(btn.dataset.lotVerify);
        if (box) box.style.display = 'block';
      });
    });

    // mobile menu
    var burger = document.querySelector('.burger'), menu = document.querySelector('.mobile-menu');
    if (burger && menu) burger.addEventListener('click', function () { menu.classList.toggle('open'); });
  });
})();
